/**
 * GrowthBook experiment definitions with frontend-specific configurations.
 * This structure is designed to map GrowthBook experiment settings to
 * the frontend application needs. This is not generated or consumed directly
 * by GrowthBook SDK, nor synchronised to Growthbook via Growthbook MCP Server
 * but rather serves as a bridge between GrowthBook and our frontend codebase.
 */

import mascotImage from 'assets/images/hero-mascot.png';
import productPreviewImage from 'assets/images/hero-product-preview.png';

export const EXPERIMENT_HOMEPAGE_HERO_SECTION = {
  KEY: 'experiment-homepage-hero-section',
  NAME: 'Experiment: Homepage Hero Section',
  VARIANTS: {
    MASCOT: 'mascot',
    PRODUCT_PREVIEW: 'product_preview',
  },
  ASSETS: {
    mascot: mascotImage,
    product_preview: productPreviewImage,
  },
  METADATA: {
    hypothesis:
      'Screenshot will increase sign-up conversions by showing product value',
    primaryMetric: 'Sign Up Conversion Rate',
  },
} as const;

export type HomepageHeroVariant =
  (typeof EXPERIMENT_HOMEPAGE_HERO_SECTION.VARIANTS)[keyof typeof EXPERIMENT_HOMEPAGE_HERO_SECTION.VARIANTS];
